import React from 'react';
import { useParams } from 'react-router-dom';
import { projects } from '../data/projects';
import './ProjectDetail.css';

const ProjectDetail = () => {
  const { projectId } = useParams();
  const project = projects.find(p => p.id === projectId);

  if (!project) {
    return <div className="not-found">Project not found</div>;
  }

  return (
    <div className="project-detail">
      <h1>{project.title}</h1>
      <p className="description">{project.fullDescription || project.description}</p>
      
      <div className="project-content">
        {project.video && (
          <div className="video-container">
            <video controls width="100%" autoPlay>
              <source src={project.video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        )}
        
        <div className="project-info">
          <h2>Project Details</h2>
          <ul>
            {project.details.map((detail, index) => (
              <li key={index}>{detail}</li>
            ))}
          </ul>
          
          <h2>Technologies Used</h2>
          <div className="tech-tags">
            {project.technologies.map((tech, index) => (
              <span key={index} className="tech-tag">{tech}</span>
            ))}
          </div>
          
          {project.link && (
            <a href={project.link} target="_blank" rel="noopener noreferrer" className="project-link">
              View Live Project
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectDetail;
